import React from 'react';

const PricingOptions = (props) => {
    return (
        props.pricingOptions.map((price, i) => {
            price.value = price.value || price.visibility;
            if (price.value !== 'hidden') {
                if (!props.user.role) {
                    if(price.value === 'all') {
                        return (
                            <option key={i} value={price.id}>
                                {price.desc} - {new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(price.amount)}
                            </option>
                        )
                    }
                } else {
                    return (
                        <option key={i} value={price.id}>
                            {price.desc} - {new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(price.amount)} 
                            {price.value === 'box-office' && ' (Box Office Only Price)'}
                        </option>
                    )
                }
            }
        })
    )
}

export default PricingOptions;


// WEBPACK FOOTER //
// ./src/components/Common/PricingOptions/PricingOptions.js